var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#2F2F37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.39 20V18.794H13.522V12.206H10.39V11H14.962V18.794H18.022V20H10.39ZM13.036 8.444C13.036 8.12 13.144 7.844 13.36 7.616C13.576 7.376 13.852 7.256 14.188 7.256C14.536 7.256 14.824 7.376 15.052 7.616C15.292 7.844 15.412 8.12 15.412 8.444C15.412 8.756 15.292 9.02 15.052 9.236C14.824 9.452 14.536 9.56 14.188 9.56C13.852 9.56 13.576 9.452 13.36 9.236C13.144 9.02 13.036 8.756 13.036 8.444Z",
    fill: "#2F2F37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f4b9585370c9f7656b12e7acbe7312f7.svg";
export { ForwardRef as ReactComponent };